import { CannedQuestionName } from '../../api/models/survey';
import { BUYER_ID } from '../../models/survey';
import { CheckoutState } from '../../state';
import { getBillingZipCode } from './pureSelectors';

export const getAnswersForQuestionsAffectingQuebecQSTTaxes = (
    surveyAnswers: Record<string, Record<string, string>>,
    state: CheckoutState,
) => ({
    [CannedQuestionName.bill]: {
        postal: getBillingZipCode(state),
    },
    [CannedQuestionName.taxRegistrationId]:
        surveyAnswers[BUYER_ID]?.[CannedQuestionName.taxRegistrationId] ?? '',
    [CannedQuestionName.qstZipCode]:
        surveyAnswers[BUYER_ID]?.[CannedQuestionName.qstZipCode] ?? '',
});
